import React from 'react';
import AcceptanceName from '../../../../../controllers/AcceptanceName';
import ToAcceptanceSetup from '../../../controllers/ToAcceptanceSetup';
import CancelCreate from '../../../controllers/CancelCreate';
import styles from './index.module.scss';
import commonStyles from '../index.module.scss';

const AddressesSetup = () => {
  return (
    <>
      <AcceptanceName
        className={commonStyles.acceptanceName}
        mode={AcceptanceName.modes.setable}
      />
      <div className={styles.rightCol}>
        <CancelCreate />
        <ToAcceptanceSetup />
      </div>
    </>
  );
};

export default AddressesSetup;
